module.exports = __webpack_public_path__ + "img/pending-trans.85892e13.svg";